import { TbRoad } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Прикордонні переходи» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Перехід кордону в заявці (етап 2).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListBorderCrossingResource: IResourceConfig = {
    title: 'Прикордонні переходи',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title'],
    },
    places: {
        top: <TopMenu current="border-crossings" />,
    },
    restUrl: '/services/border_crossings',
    pageUrl: '/settings/border-crossings',
    pageConfig: {
        title: 'Прикордонні переходи',
        icon: <TbRoad />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
